import React, { Component } from 'react';
import { Container, Divider, Grid, Header, Loader } from 'semantic-ui-react';

// Styles
import './App.css';

// Custom components
import AboutMe from './components/AboutMe';
import IconMenu from './components/IconMenu';
import IconMenuMobile from './components/IconMenuMobile';
import SideCard from './components/SideCard';
import SideCardMobile from './components/SideCardMobile';
import Education from './components/Education';
import Experience from './components/Experience';
import Interests from './components/Interests';
import ContactMe from './components/ContactMe';
// import Blog from './components/Blog';
// import { getRandomImage } from './utils/Images';

import backgroundImage from './images/backgroundImage.jpg';

class App extends Component {
  state = {
    backgroundImage
  }

  handleContextRef = contextRef => this.setState({ contextRef })

  render() {
    const { backgroundImage, contextRef } = this.state;
    return (
      <div ref={this.handleContextRef}>
        <div className="main" style={{ backgroundImage: `url(${backgroundImage})` }}>
        </div>
        {(() => {
          if (backgroundImage) {
            setTimeout(null, 500);
            return;
          }

          return <Loader active inline='centered' />;
        })()}
        <Container>
          <Grid>
            <Grid.Column textAlign="center" className="mobile tablet only" width={16}>
              <IconMenuMobile />
            </Grid.Column>
            <Grid.Column width={16}>
              <Header size="huge"></Header>
            </Grid.Column>
            <Grid.Column className="computer only" width={4}>
              <SideCard contextRef={contextRef} />
            </Grid.Column>
            <Grid.Column className="mobile tablet only" width={16}>
              <SideCardMobile />
            </Grid.Column>
            <Grid.Column widescreen={10} largeScreen={10} computer={10} tablet={16} mobile={16}>
              <AboutMe />
              <Divider horizontal />
              <Experience />
              <Divider horizontal />
              <Education />
              <Divider horizontal />
              <Interests />
              {/* <Divider horizontal />
              <Blog /> */}
              <Divider horizontal />
              <ContactMe />
              <Divider horizontal />
            </Grid.Column>
            <Grid.Column className="computer only" width={2}>
              <IconMenu contextRef={contextRef} />
            </Grid.Column>
          </Grid>
        </Container>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js